import { Component, OnInit } from '@angular/core';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-admin-config-ivirtual',
  templateUrl: './admin-config-ivirtual.component.html',
  styleUrls: ['./admin-config-ivirtual.component.css']
})
export class AdminConfigIvirtualComponent implements OnInit {

  isLoading = false;
  isLoadingModal = false;
  ivirtualClientList: any = [];
  idCustomer: 0;
  accion: string = '';
  idIvirtualConfig: 0;

  toggleSelected = false;

  checkHeartRate = false;
  checkRespiratoryRate = false;
  checkHbpRisk = false;
  checkHrv = false;
  checkStressLevel = false;
  checkVisualAge = false;
  checkBmiFace = false;
  checkCardioScore = false;
  isActive = false;

  constructor(
    public mantenedorService: MantenedorService
  ) {}

  ngOnInit(): void {
    this.getClientIvirtual();
  }

  getClientIvirtual() {
    this.isLoading = true;
    this.mantenedorService.getClientIvirtual().then(data => {
      
      this.ivirtualClientList = data['datos'].data;
      this.isLoading = false;
    });
  }
  
  toggleAll(toggleSelected){
    if(toggleSelected == true){
      this.checkHeartRate = true;
      this.checkRespiratoryRate = true;
      this.checkHbpRisk = true;
      this.checkHrv = true;
      this.checkStressLevel = true;
      this.checkVisualAge = true;
      this.checkBmiFace = true;
      this.checkCardioScore = true;
    }else if(toggleSelected == false) {
      this.checkHeartRate = false;
      this.checkRespiratoryRate = false;
      this.checkHbpRisk = false;
      this.checkHrv = false;
      this.checkStressLevel = false;
      this.checkVisualAge = false;
      this.checkBmiFace = false;
      this.checkCardioScore = false;
    }
  }

  saveConfig(){

    let params = {
      'idIvirtualConfig': this.idIvirtualConfig,
      'cus_id': this.idCustomer,
      'accion': this.accion,
      'isActive': this.isActive,
      'checkHeartRate': this.checkHeartRate,
      'checkRespiratoryRate': this.checkRespiratoryRate,
      'checkHbpRisk': this.checkHbpRisk,
      'checkHrv': this.checkHrv,
      'checkStressLevel': this.checkStressLevel,
      'checkVisualAge': this.checkVisualAge,
      'checkBmiFace': this.checkBmiFace,
      'checkCardioScore': this.checkCardioScore,
    };

    this.mantenedorService.postSaveConfigsIVirtual(params).then(data => {

      Swal.fire({
        allowOutsideClick: false,
        html: ` <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Guardado Correctamente</h1>
      </div>`,
        showConfirmButton: true,
        timer: 8000
      });
      // ✅ Cierra el modal con jQuery
      ($('#modalVitalsConfig') as any).modal('hide');

      this.getClientIvirtual();
    });
  }

  getConfigClient(idCliente) {
    this.isLoadingModal = true;

    this.idCustomer = idCliente;

    this.mantenedorService.getConfigsIVirtual(idCliente).then(data => {

      this.isLoadingModal = false;
      if(data['status'] == true){
        this.accion = 'update';
        this.checkHeartRate = data['datos'].calc_heart_rate;
        this.checkRespiratoryRate = data['datos'].calc_respiratory_rate;
        this.checkHbpRisk = data['datos'].calc_hbp_risk;
        this.checkHrv = data['datos'].calc_hrv;
        this.checkStressLevel = data['datos'].calc_stress_level;
        this.checkVisualAge = data['datos'].calc_visual_age;
        this.checkBmiFace = data['datos'].calc_bmi_face;
        this.checkCardioScore = data['datos'].calc_cardio_score;
        this.isActive = data['datos'].is_active;
        this.idIvirtualConfig = data['datos'].id_ivirtual_config;
      }else if (data['status'] == false){
        this.accion = 'update';
        this.checkHeartRate = false;
        this.checkRespiratoryRate = false;
        this.checkHbpRisk = false;
        this.checkHrv = false;
        this.checkStressLevel = false;
        this.checkVisualAge = false;
        this.checkBmiFace = false;
        this.checkCardioScore = false;
        this.isActive = false;
        this.idIvirtualConfig = 0;
      }
    });

  }
}
